import React, { useState, useEffect, useMemo } from "react";
import { ColumnConfig } from "@app/shared/waffles";
import { Waffles } from "@app/shared/waffles/Waffles";
import { FlyoutFooter } from "@app/shared/Flyouts";
import OperationsService from "@app/operations/operationsService";

interface UnfinishedProjectsFlyoutContentProps {
  runDate: string;
  clientId: number;
  lineOfBusiness: string;
}

const operationsService = new OperationsService();

const UnfinishedProjectsFlyoutContent: React.FC<UnfinishedProjectsFlyoutContentProps> = ({
  runDate,
  clientId,
  lineOfBusiness,
}) => {
  const [projectData, setProjectData] = useState<{ projectName: string }[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string>("");

  const unfinishedProjectsColumns: ColumnConfig = {
    projectName: {
      displayText: "Project Name",
      noSort: true,
      sizeContentToFit: true,
      testId: "unfinished-projects__project-name-output",
    },
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const result = await operationsService.getUnfinishedProjectNames(
          runDate,
          clientId,
          lineOfBusiness
        );
        setProjectData(result);
      } catch (err) {
        setError("Error fetching unfinished project names");
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [runDate, clientId, lineOfBusiness]);

  const tableData = useMemo(() => {
    return projectData.map((project, index) => ({
      key: index.toString(),
      projectName: project.projectName,
    }));
  }, [projectData]);

  if (loading) {
    return <div>Loading...</div>;
  }

  if (error) {
    return <div>{error}</div>;
  }

  return (
    <div>
      <Waffles
        columns={unfinishedProjectsColumns}
        data={tableData}
        enablePagination={false}
        // passThroughSorting={true}
        testId="unfinished-projects__table"
      />
      <FlyoutFooter
        submitButton={null}
      />
    </div>
  );
};

export default UnfinishedProjectsFlyoutContent;